import clsx from 'clsx'
import { Document, Template } from '@/assets/icons'

export type DocumentFileType = 'file' | 'template'

export type DocumentFileStatus = 'in_progress' | 'complete'

type DocumentFileProps = {
  /** the filename of the document */
  filename: string
  /** determines the icon and styling */
  type: DocumentFileType
  /** the status of the row */
  status: DocumentFileStatus
}

/**
 * DOCX filename row: icon rail with vertical divider, then label.
 */
export function DocumentFile({ filename, type, status }: DocumentFileProps) {
  const isTemplate = type === 'template'
  const isComplete = status === 'complete'

  const Icon = isTemplate ? Template : Document

  return (
    <div
      className={clsx(
        'flex min-h-10 items-stretch gap-[10px] rounded-[5px] border border-solid pr-3',
        isTemplate && 'border-brand-neutral-300 bg-white',
        !isTemplate && isComplete && 'border-brand-200 bg-brand-50',
        !isTemplate && !isComplete && 'border-true-gray-200 bg-white'
      )}
    >
      <div
        className={clsx(
          'flex w-10 shrink-0 items-center justify-center self-stretch rounded-bl-[5px] rounded-tl-[5px] border-r border-solid',
          isTemplate && 'border-brand-neutral-300',
          !isTemplate && isComplete && 'border-brand-200',
          !isTemplate && !isComplete && 'border-true-gray-200'
        )}
        aria-hidden
      >
        <Icon
          className={clsx(
            'h-5 w-5 shrink-0',
            isTemplate && 'text-brand-neutral-950',
            !isTemplate && isComplete && 'text-brand-800',
            !isTemplate && !isComplete && 'text-true-gray-500'
          )}
        />
      </div>
      <div className="flex min-w-0 flex-1 items-center">
        <span
          className={clsx(
            'min-w-0 truncate text-sm',
            isTemplate && 'font-medium tracking-[-0.15px] text-brand-neutral-950',
            !isTemplate && isComplete && 'font-medium text-brand-800',
            !isTemplate && !isComplete && 'text-true-gray-500'
          )}
          title={filename}
        >
          {filename}
        </span>
      </div>
    </div>
  )
}
